import pro from './modules/pro';

export default {
  namespaced: true,
  modules: {
    pro,
  },
  state () {
    return {};
  },
};
